import { esc } from '@/lib/dom';

type ToastKind = 'info' | 'ok' | 'del' | 'warn';

export function toast(msg: string, kind: ToastKind = 'info', action?: { label: string; fn: () => void }): void {
  const stack = document.getElementById('toasts');
  if (!stack) return;
  const el = document.createElement('div');
  el.className = `toast ${kind}`;
  el.innerHTML = `<span>${esc(msg)}</span>`;
  const kill = (): void => {
    clearTimeout(timer);
    el.classList.remove('in');
    el.addEventListener('transitionend', () => el.remove(), { once: true });
  };
  if (action) {
    const b = document.createElement('button');
    b.className = 'toast-act';
    b.textContent = action.label;
    b.addEventListener('click', () => { action.fn(); kill(); });
    el.appendChild(b);
  }
  stack.appendChild(el);
  requestAnimationFrame(() => el.classList.add('in'));
  const timer = window.setTimeout(kill, action ? 6000 : 2800);
}
